import { defineMessages } from 'react-intl';

const translations = {
  orderCard: {
    status: {
      concept: {
        id: 'properties.concept',
        defaultMessage: 'Concept',
        description: 'label of the order status concept',
      },
      accepted: {
        id: 'properties.accepted',
        defaultMessage: 'Accepted',
        description: 'label of the order status accepted',
      },
      confirmed: {
        id: 'properties.confirmed',
        defaultMessage: 'Confirmed',
        description: 'label of the order status confirmed',
      },
      finished: {
        id: 'properties.finished',
        defaultMessage: 'Finished',
        description: 'label of the order status finished',
      },
    },
  },
};

export default defineMessages(translations);
